module.exports = __webpack_public_path__ + "media/peao-do-bau.b8b2d2c6.mp3";